import {Locale} from "@data/locales";

type ToggleLanguage = string;

export const toggleLanguage: Record<Locale, ToggleLanguage> = {
	en: "See in Spanish",
	es: "Ver en Inglés",
};
